import { render, staticRenderFns } from "./reportsMain.vue?vue&type=template&id=298ba647&scoped=true"
import script from "./reportsMain.vue?vue&type=script&lang=js"
export * from "./reportsMain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_6d50957d97179d0c2dc3f7fe111d18c4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "298ba647",
  null
  
)

export default component.exports